"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppCourseTabs {
    init() {
        var _a;
        const root = document.querySelector("[data-course-categories]");
        if (!root)
            return;
        const tabs = Array.from(root.querySelectorAll("[data-course-tab]"));
        const panels = Array.from(root.querySelectorAll("[data-course-panel]"));
        (_a = root
            .querySelector("[data-course-tablist]")) === null || _a === void 0 ? void 0 : _a.setAttribute("role", "tablist");
        panels.forEach((panel) => {
            panel.setAttribute("role", "tabpanel");
            panel.tabIndex = 0;
        });
        const select = (tab) => {
            tabs.forEach((item) => {
                const active = item === tab;
                item.classList.toggle("is-active", active);
                item.setAttribute("aria-selected", String(active));
                item.tabIndex = active ? 0 : -1;
            });
            panels.forEach((panel) => {
                panel.hidden = panel.dataset.coursePanel !== tab.dataset.courseTab;
            });
        };
        tabs.forEach((tab, index) => {
            tab.setAttribute("role", "tab");
            tab.setAttribute("aria-controls", `course-panel-${tab.dataset.courseTab}`);
            tab.removeAttribute("aria-current");
            tab.addEventListener("click", (event) => {
                if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                    return;
                event.preventDefault();
                select(tab);
                const url = new URL(window.location.href);
                url.searchParams.set("categoria", tab.dataset.courseTab);
                window.history.replaceState(window.history.state, "", url);
            });
            tab.addEventListener("keydown", (event) => {
                let next = index;
                if (event.key === "ArrowRight")
                    next = (index + 1) % tabs.length;
                else if (event.key === "ArrowLeft")
                    next = (index + tabs.length - 1) % tabs.length;
                else if (event.key === "Home")
                    next = 0;
                else if (event.key === "End")
                    next = tabs.length - 1;
                else if (event.key !== " ")
                    return;
                event.preventDefault();
                tabs[next].focus();
                tabs[next].click();
            });
        });
        const initial = tabs.find((tab) => tab.classList.contains("is-active"));
        if (initial)
            select(initial);
    }
}
exports.default = AppCourseTabs;
